var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"text-center py-16"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"48"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }